import { NextPage } from 'next';
import React from 'react';
import { TermsOfUseContent } from 'containers/privacy';

const PrivacyPolicy: NextPage = () => {
  return (
    <>
      <TermsOfUseContent />
    </>
  );
};

export default PrivacyPolicy;
